import React, { memo } from 'react'
import { OutlinedField } from '../Forms'

const ContentField = memo(({ classes, handleChange, value }) => {
  return (
    <OutlinedField
      ltr
      label="Content"
      className={classes.textField}
      value={value}
      onChange={handleChange('content')}
      required
    />
  )
})

export default ContentField
